import { OrderPayablesToolPanel } from "../OrderPayablesToolPanel";
import { DataSource, HorizontalSpacer, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSubmittalSettlementsTable extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelSubmitCount: Label;
    layoutOrderPayablesToolPanel: OrderPayablesToolPanel;
    sourceOrderPayables: DataSource;
    tableReadyToSubmitOrderPayables: Table;
    textboxTotalAmount: Textbox;
}
